var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#764ABC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st0",
    d: "M320.4,318.7c13.5-1.4,23.7-13,23.2-26.9c-0.5-13.9-12.1-25.1-26-25.1h-0.9 c-14.4,0.5-25.5,12.5-25.1,26.9c0.5,7,3.3,13,7.4,17.2c-15.8,31.1-39.9,53.9-76.2,72.9c-24.6,13-50.2,17.7-75.7,14.4 c-20.9-2.8-37.2-12.1-47.4-27.4c-14.9-22.8-16.3-47.4-3.7-72c8.8-17.7,22.8-30.7,31.6-37.2c-1.9-6-4.6-16.3-6-23.7 c-67.3,48.8-60.4,114.7-39.9,145.9c15.3,23.2,46.4,37.6,80.8,37.6c9.3,0,18.6-0.9,27.9-3.3C249.8,406.5,294.9,371.2,320.4,318.7z  M402.2,261.1c-35.3-41.3-87.3-64.1-146.8-64.1h-7.4c-4.2-8.4-13-13.9-22.8-13.9h-0.9c-14.4,0.5-25.5,12.5-25.1,26.9 c0.5,13.9,12.1,25.1,26,25.1h0.9c10.2-0.5,19-7,22.8-15.8h8.4c35.3,0,68.7,10.2,98.9,30.2c23.2,15.3,39.9,35.3,49.2,59.5 c7.9,19.5,7.4,38.6-0.9,54.8c-13,24.6-34.8,38.1-63.6,38.1c-18.6,0-36.2-5.6-45.5-9.8c-5.1,4.6-14.4,12.1-20.9,16.7 c20,9.3,40.4,14.4,59.9,14.4c44.6,0,77.6-24.6,90.1-49.2C437.9,347.1,437,300.6,402.2,261.1z M166.2,326.6 c0.5,13.9,12.1,25.1,26,25.1h0.9c14.4-0.5,25.5-12.5,25.1-26.9c-0.5-13.9-12.1-25.1-26-25.1h-0.9c-0.9,0-2.3,0-3.3,0.5 c-19-31.6-26.9-66-24.2-103.1c1.9-27.9,11.1-52,27.4-72c13.5-17.2,39.5-25.5,57.1-26c49.2-0.9,70.1,60.4,71.5,85 c6,1.4,16.3,4.6,23.2,7c-5.6-75.2-52-114.3-96.6-114.3c-41.8,0-80.4,30.2-95.7,74.8c-21.4,59.5-7.4,116.6,18.6,161.6 C167.1,316.4,165.7,321.5,166.2,326.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedux);
export default __webpack_public_path__ + "static/media/redux.bebc8109dd6da3549dec06ffcd75c844.svg";
export { ForwardRef as ReactComponent };